import * as ambassadorWixDataV1DataService from './data-v1-data-service-data.http.js';
import * as ambassadorWixDataV1DataServiceTypes from './data-v1-data-service-data.types.js';
import * as ambassadorWixDataV1DataServiceUniversalTypes from './data-v1-data-service-data.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function insert(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.InsertRequest,
  ambassadorWixDataV1DataServiceTypes.InsertRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.InsertResponse,
  ambassadorWixDataV1DataServiceTypes.InsertResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.insert(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function update(): __PublicMethodMetaInfo<
  'PUT',
  { itemId: string },
  ambassadorWixDataV1DataServiceUniversalTypes.UpdateRequest,
  ambassadorWixDataV1DataServiceTypes.UpdateRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.UpdateResponse,
  ambassadorWixDataV1DataServiceTypes.UpdateResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions = ambassadorWixDataV1DataService.update(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PUT',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function save(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.SaveRequest,
  ambassadorWixDataV1DataServiceTypes.SaveRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.SaveResponse,
  ambassadorWixDataV1DataServiceTypes.SaveResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.save(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/save',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function get(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixDataV1DataServiceUniversalTypes.GetRequest,
  ambassadorWixDataV1DataServiceTypes.GetRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.GetResponse,
  ambassadorWixDataV1DataServiceTypes.GetResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions = ambassadorWixDataV1DataService.get(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function remove(): __PublicMethodMetaInfo<
  'DELETE',
  { itemId: string },
  ambassadorWixDataV1DataServiceUniversalTypes.RemoveRequest,
  ambassadorWixDataV1DataServiceTypes.RemoveRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.RemoveResponse,
  ambassadorWixDataV1DataServiceTypes.RemoveResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions = ambassadorWixDataV1DataService.remove(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function truncate(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.TruncateRequest,
  ambassadorWixDataV1DataServiceTypes.TruncateRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.TruncateResponse,
  ambassadorWixDataV1DataServiceTypes.TruncateResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.truncate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/truncate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function query(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.QueryRequest,
  ambassadorWixDataV1DataServiceTypes.QueryRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.QueryResponse,
  ambassadorWixDataV1DataServiceTypes.QueryResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.query(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function aggregate(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.AggregationRequest,
  ambassadorWixDataV1DataServiceTypes.AggregationRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.AggregationResponse,
  ambassadorWixDataV1DataServiceTypes.AggregationResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.aggregate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/aggregate',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function count(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.CountRequest,
  ambassadorWixDataV1DataServiceTypes.CountRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.CountResponse,
  ambassadorWixDataV1DataServiceTypes.CountResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.count(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function distinct(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.DistinctRequest,
  ambassadorWixDataV1DataServiceTypes.DistinctRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.DistinctResponse,
  ambassadorWixDataV1DataServiceTypes.DistinctResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.distinct(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/distinct',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkInsert(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkInsertRequest,
  ambassadorWixDataV1DataServiceTypes.BulkInsertRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkInsertResponse,
  ambassadorWixDataV1DataServiceTypes.BulkInsertResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.bulkInsert(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/insert',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkSave(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkSaveRequest,
  ambassadorWixDataV1DataServiceTypes.BulkSaveRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkSaveResponse,
  ambassadorWixDataV1DataServiceTypes.BulkSaveResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.bulkSave(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/save',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdate(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkUpdateRequest,
  ambassadorWixDataV1DataServiceTypes.BulkUpdateRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkUpdateResponse,
  ambassadorWixDataV1DataServiceTypes.BulkUpdateResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.bulkUpdate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkRemove(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkRemoveRequest,
  ambassadorWixDataV1DataServiceTypes.BulkRemoveRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkRemoveResponse,
  ambassadorWixDataV1DataServiceTypes.BulkRemoveResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixDataV1DataService.bulkRemove(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/remove',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryReferenced(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.QueryReferencedRequest,
  ambassadorWixDataV1DataServiceTypes.QueryReferencedRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.QueryReferencedResponse,
  ambassadorWixDataV1DataServiceTypes.QueryReferencedResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataService.queryReferenced(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/query-referenced',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkInsertReferences(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkInsertReferencesRequest,
  ambassadorWixDataV1DataServiceTypes.BulkInsertReferencesRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkInsertReferencesResponse,
  ambassadorWixDataV1DataServiceTypes.BulkInsertReferencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataService.bulkInsertReferences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/references/insert',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkReplaceReferences(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkReplaceReferencesRequest,
  ambassadorWixDataV1DataServiceTypes.BulkReplaceReferencesRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkReplaceReferencesResponse,
  ambassadorWixDataV1DataServiceTypes.BulkReplaceReferencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataService.bulkReplaceReferences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/references/replace',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkRemoveReferences(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.BulkRemoveReferencesRequest,
  ambassadorWixDataV1DataServiceTypes.BulkRemoveReferencesRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.BulkRemoveReferencesResponse,
  ambassadorWixDataV1DataServiceTypes.BulkRemoveReferencesResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataService.bulkRemoveReferences(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/references/remove',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function isReferenced(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixDataV1DataServiceUniversalTypes.IsReferencedRequest,
  ambassadorWixDataV1DataServiceTypes.IsReferencedRequest,
  ambassadorWixDataV1DataServiceUniversalTypes.IsReferencedResponse,
  ambassadorWixDataV1DataServiceTypes.IsReferencedResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDataV1DataService.isReferenced(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/is-referenced',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Item as ItemOriginal,
  InsertRequest as InsertRequestOriginal,
  Segment as SegmentOriginal,
  SegmentWithLiterals as SegmentWithLiteralsOriginal,
  Options as OptionsOriginal,
  InsertResponse as InsertResponseOriginal,
  UpdateRequest as UpdateRequestOriginal,
  UpdateResponse as UpdateResponseOriginal,
  SaveRequest as SaveRequestOriginal,
  SaveResponse as SaveResponseOriginal,
  PatchRequest as PatchRequestOriginal,
  PatchResponse as PatchResponseOriginal,
  PatchWhereRequest as PatchWhereRequestOriginal,
  PatchWhereResponse as PatchWhereResponseOriginal,
  GetRequest as GetRequestOriginal,
  ReadOptions as ReadOptionsOriginal,
  GetResponse as GetResponseOriginal,
  RemoveRequest as RemoveRequestOriginal,
  RemoveResponse as RemoveResponseOriginal,
  TruncateRequest as TruncateRequestOriginal,
  TruncateResponse as TruncateResponseOriginal,
  QueryRequest as QueryRequestOriginal,
  Query as QueryOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  Paging as PagingOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryResponse as QueryResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  Cursors as CursorsOriginal,
  AggregationRequest as AggregationRequestOriginal,
  AggregationResponse as AggregationResponseOriginal,
  CountRequest as CountRequestOriginal,
  CountResponse as CountResponseOriginal,
  DistinctRequest as DistinctRequestOriginal,
  DistinctResponse as DistinctResponseOriginal,
  BulkInsertRequest as BulkInsertRequestOriginal,
  BulkInsertResponse as BulkInsertResponseOriginal,
  BulkError as BulkErrorOriginal,
  ApplicationError as ApplicationErrorOriginal,
  Details as DetailsOriginal,
  BulkSaveRequest as BulkSaveRequestOriginal,
  BulkSaveResponse as BulkSaveResponseOriginal,
  BulkUpdateRequest as BulkUpdateRequestOriginal,
  BulkUpdateResponse as BulkUpdateResponseOriginal,
  BulkPatchRequest as BulkPatchRequestOriginal,
  Entry as EntryOriginal,
  BulkPatchResponse as BulkPatchResponseOriginal,
  BulkRemoveRequest as BulkRemoveRequestOriginal,
  BulkRemoveRequestEntry as BulkRemoveRequestEntryOriginal,
  BulkRemoveResponse as BulkRemoveResponseOriginal,
  QueryReferencedRequest as QueryReferencedRequestOriginal,
  Order as OrderOriginal,
  OrderWithLiterals as OrderWithLiteralsOriginal,
  QueryReferencedResponse as QueryReferencedResponseOriginal,
  ReferencedEntity as ReferencedEntityOriginal,
  ReferencedEntityEntityOneOf as ReferencedEntityEntityOneOfOriginal,
  BulkInsertReferencesRequest as BulkInsertReferencesRequestOriginal,
  Reference as ReferenceOriginal,
  BulkInsertReferencesResponse as BulkInsertReferencesResponseOriginal,
  BulkReplaceReferencesRequest as BulkReplaceReferencesRequestOriginal,
  BulkReplaceReferencesResponse as BulkReplaceReferencesResponseOriginal,
  BulkRemoveReferencesRequest as BulkRemoveReferencesRequestOriginal,
  BulkRemoveReferencesResponse as BulkRemoveReferencesResponseOriginal,
  IsReferencedRequest as IsReferencedRequestOriginal,
  IsReferencedResponse as IsReferencedResponseOriginal,
  RestoreFromTrashBinRequest as RestoreFromTrashBinRequestOriginal,
  RestoreFromTrashBinResponse as RestoreFromTrashBinResponseOriginal,
} from './data-v1-data-service-data.types.js';
